module.exports = __webpack_public_path__ + "img/cimpress.d0ec94ec.png";